export default __webpack_public_path__ + "static/media/features_sidepane.e39869b0.png";